/**
 * 主题选项
 * 新增样式主题色选项说明：
 * 主题提供器会对value使用-进行拆分，逐个添加到body的类中，类名构造为 theme-xxx，xxx为拆分出来的名称
 * 如value为 default-scaled，那么添加到body的类为：theme-default、theme-scaled
 * src/styles/theme.css 中定义了 theme-default、theme-scaled等样式
 */
export const THEME_OPTIONS = [
  {
    name: '默认',
    value: 'default',
  },
  {
    name: '紧凑',
    value: 'default-scaled',
  },
] as const;
export type ThemeValue = (typeof THEME_OPTIONS)[number]['value'];
